import { render } from "./EventRegComponent.vue?vue&type=template&id=075bb490&scoped=true&ts=true"
import script from "./EventRegComponent.vue?vue&type=script&lang=ts"
export * from "./EventRegComponent.vue?vue&type=script&lang=ts"

import "./EventRegComponent.vue?vue&type=style&index=0&id=075bb490&scoped=true&lang=css"
import "./EventRegComponent.vue?vue&type=style&index=1&id=075bb490&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-075bb490"]])

export default __exports__